module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("support_post_menu", [["h2",{},[["span",{},[],[["tag","__text",true]]]]],["div",{"class":"links-wrapper"},[["div",{"class":"row clearfix"},[["div",{"class":"col-1"},[["textNode",{"text":"Guide"}]]]]],["div",{"id":"supportPostTitles"}]]]]);
fox.registerTemplate("support_post_menu_row", [["div",{"class":"row clearfix"},[["div",{"class":"col-1"},[["a",{"href":"/support/post/&&0&&"},[["span",{},[],[["title","__text",true]]]],[["id","href"]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!../common/templates/support/post_menu.tpl
// module id = 461
// module chunks = 2